export default __webpack_public_path__ + "static/media/img.23a0166a.jpg";